import React, { useState, useCallback, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import { perfFacilitiesHeadCells } from "../util/headcells-util";
import {
  fetchPerfFacilitiesData,
  addNewPerfFacility,
  updatePerfFacilityRecord,
  removePerfFacilityRecord,
  fetchPerfFacilityById,
} from "../services/performingFacilities-service";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { handleIsActive, showPopupDetails, validateAndSanitizeUrl } from "../util/common";
import _ from "lodash";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible } from "../util/common";
import { PFTRB } from "../util/component-codes";
import { getAllFacilities } from "../services/sendingFacilities-service";
import { Autocomplete } from "@mui/material";
import Cookies from "js-cookie";

const PerformingFacility = () => {
  const [show, setShow] = useState(false);

  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [form, setForm] = useState({});
  const [alertMessage, setAlertMessage] = useState();

  const [filter, setFilter] = useState({});
  const [isAddNew, setIsAddNew] = useState(false);
  const [facilityData, setFacilityData] = useState([]);
  const [facilityDetails, setFacilityDetails] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [validated, setValidated] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [facilitiesData, setFacilitiesData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);

  const [statesData, setStatesData] = useState([]);
  const [statesCheckedValues, setStatesCheckedValues] = useState([]);
  const [copyToSendingFacilityFlag, setCopyToSendingFacilityFlag] = useState(false);
  
  const handleClose = () => setShow(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);
  const handleCloseDetailsModal = () => setShowDetailsModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let facilityName = filter?.searchNameText ? filter?.searchNameText : "";
    let facilityClia = filter?.searchCliaText ? filter?.searchCliaText : "";
    let city = filter?.searchCityText ? filter?.searchCityText : "";
    let state = filter?.states?.length > 0 ? filter?.states : [];
    let isActive = [];

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (facilityName !== "") {
      params += `&name=${facilityName}`;
    }
    if (city !== "") {
      params += `&city=${city}`;
    }
    if (state.length > 0) {
      params += `&state=${state.toString()}`;
    }
    if (facilityClia !== "") {
      params += `&clia=${facilityClia}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleStatesCheckboxChange = (event) => {
    let copyCheckedValues = [...statesCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setStatesCheckedValues(copyCheckedValues);
    setFilterField("states", copyCheckedValues);
  };

  const getFacilitiesData = useCallback(
    async (filter) => {
      let response = await fetchPerfFacilitiesData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );
      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setFacilitiesData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const addFacility = async (newPayload, copyToSendingFacilityFlag) => {
    let data = await addNewPerfFacility(newPayload, copyToSendingFacilityFlag);
    if (data.performingFacilityId != null) {
      setIsAdded(true);
    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const updateFacility = async (newPayload) => {
    let payload = {
      ...newPayload,
      performingFacilityId: selectedRow.performingFacilityId,
    };
    let data = await updatePerfFacilityRecord(payload);
    if (data.performingFacilityId != null) {
      setIsUpdated(true);
      setSelectedRow(data);
    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const removeFacility = async () => {
    let response = await removePerfFacilityRecord(
      selectedRow.performingFacilityId
    );
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };

  const getStateDropdownValues = async () => {
    let response = await fetchCodeSetTable("State");
    if (response.ok) {
      let data = await response.json();
      setStatesData(data.refTableValues);
    }
  };

  const getFacilityDetails = async (performingFacilityId) => {
    let response = await fetchPerfFacilityById(performingFacilityId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setFacilityDetails(data);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
        setShowDetailsModal(true);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const getFacilities = async () => {
    let response = await getAllFacilities();
    if (response.ok) {
      let data = await response.json();
      setFacilityData(data);
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  useEffect(() => {
    getFacilitiesData(filter);
  }, [pageNo, recordsPerPage, getFacilitiesData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getFacilitiesData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getFacilitiesData]);

  useEffect(() => {
    getFacilities();
    getStateDropdownValues();
  }, []);

  useEffect(() => {
    if (pageNo >= facilitiesData?.totalPages) {
      facilitiesData?.totalPages !== 0 &&
        setPageNo(facilitiesData?.totalPages - 1);
    }
  }, [facilitiesData]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    setForm({});
    setValidated(false);
    setIsAddNew(true);
    setShow(true);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    let response = await fetchPerfFacilityById(
      selectedRow.performingFacilityId
    );
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        const parsedData = {
          performingFacilityName: data?.performingFacilityName,
          clia: data?.clia,
          addressId: data?.address?.addressId,
          addressLine1: data?.address?.addressLine1,
          addressLine2: data?.address?.addressLine2,
          city: data?.address?.city,
          state: data?.address?.state,
          zip: data?.address?.zip,
          phoneNo: data?.address?.phoneNo,
          isActive: data?.isActive,
          sendingFacility: data?.sendingFacilityId,
        };
        setForm(parsedData);
        setValidated(false);
        setIsAddNew(false);
        setShow(true);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };
  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    const newPayload = {
      performingFacilityName: form.performingFacilityName,
      clia: form.clia,
      isActive: form.isActive,
      sendingFacilityId: form.sendingFacility,
      address: {
        addressId: form.addressId,
        addressLine1: form.addressLine1,
        addressLine2: form.addressLine2,
        city: form.city,
        state: form.state,
        zip: form.zip,
        phoneNo: form.phoneNo,
      },
    };
    if (event.currentTarget.checkValidity() === true) {
      isAddNew ? addFacility(newPayload, copyToSendingFacilityFlag) : updateFacility(newPayload);
      setShow(false);
    }
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getFacilitiesData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setStatesCheckedValues([]);
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(PFTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted Performing Facility record";
    } else if (isAdded) {
      return "Successfully added new Performing Facility!";
    } else if (isUpdated) {
      return "Successfully updated Performing Facility!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (statesCheckedValues.length > 0) {
      active.push("0");
    }
    if (filter?.active || filter?.inactive) {
      active.push("1");
    }
    return active;
  };

  const filterOptions = (options, params) => {
    if (params.inputValue === "") return options;
    let filtered = options.filter((item) => {
      let facilityInfo = item.sendingFacilityName + "-" + item.clia;

      return facilityInfo
        .toLowerCase()
        .includes(params.inputValue.toLowerCase());
    });
    return filtered;
  };

  const showFacilityData = (facilityData, facilityDetails) => {
    let sendingFacility=facilityData
    .find(
      (obj) =>
        obj?.sendingFacilityId ===
        facilityDetails?.sendingFacilityId
    );
    
    let sendingFacilityIdentifier= sendingFacility!==undefined?(sendingFacility?.sendingFacilityIdentifier.trim()+" - "):"";
    let sendingFacilityName=sendingFacility!==undefined?(sendingFacility?.sendingFacilityName):"Facility not found";

    return sendingFacilityIdentifier+sendingFacilityName;
  };

  return (
    <>
      <Container fluid className="facilitiesContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              Performing Facility Table
            </Row>
            <Row className="tableSubtitle generalFont">
              View all the Performing Facilities available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={perfFacilitiesHeadCells}
          rows={facilitiesData?.genericList}
          pages={facilitiesData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New Performing Facility"
          addButtonAction={handleAdd}
          closeButtonAction={handleClose}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isPerfFacilityTable={true}
          getFacilityDetails={getFacilityDetails}
        />
      </Container>

      <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailsModal}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            <div className="cardBody">
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}details-icon.png`}
                style={{
                  width: "32px",
                  height: "32px",
                  marginRight: "15px",
                }}
                alt=""
              ></img>
              Performing Facility Details
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <Row>
            <Col sm={4}>
              <div className="repLoincModalTitle">Facility Name:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.performingFacilityName)}
              </div>
            </Col>
            <Col sm={4}>
              <div className="repLoincModalTitle">Performing Facility ID:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.performingFacilityId)}
              </div>
            </Col>
            <Col sm={4}>
              <div className="repLoincModalTitle">Sending Facility:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(
                  showFacilityData(facilityData, facilityDetails)
                )}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "20px" }}></hr>
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">CLIA:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.clia)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Status:</div>
              <div
                className={`${
                  facilityDetails?.isActive
                    ? "activeColStyle"
                    : "inactiveColStyle"
                }`}
                style={{ width: "80px" }}
              >
                {facilityDetails?.isActive ? "Active" : "Inactive"}
              </div>
            </Col>
          </Row>

          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row>
            <Row style={{ marginBottom: "40px" }}>
              <div className="cardBody">Address Details</div>
            </Row>
            <Col sm={6}>
              <div className="repLoincModalTitle">Street Address 1:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.addressLine1)}
              </div>
            </Col>
            <Col sm={6}>
              <div className="repLoincModalTitle">Street Address 2:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.addressLine2)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">City:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.city)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">State:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.state)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Phone Number:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.phoneNo)}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              {isAddNew
                ? "Add New Performing Facility"
                : "Update Performing Facility"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Group
                    className="mb-3"
                    controlId="performingFacilityName"
                  >
                    <Form.Label className="modalLabel generalFont">
                      Facility Name <i className="text-danger">(required)</i>
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={250}
                      placeholder="Hint Text"
                      required
                      value={form.performingFacilityName}
                      onChange={(e) =>
                        setField("performingFacilityName", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="clia">
                    <Form.Label className="modalLabel generalFont">
                      CLIA <i className="text-danger">(required)</i>
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={15}
                      pattern="[a-zA-Z0-9]{9,}"
                      title="CLIA must be at least 9 characters long"
                      placeholder="Hint Text"
                      required
                      value={form.clia}
                      onChange={(e) => setField("clia", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <Form.Group className="mb-3" controlId="isActive">
                    <Form.Label className="modalLabel generalFont">
                      Sending Facility (Name-CLIA){" "}
                    </Form.Label>
                    {facilityData && (
                      <Autocomplete
                        onChange={(event, newValue) => {
                          setField("sendingFacility", newValue);
                        }}
                        value={form.sendingFacility}
                        options={facilityData.sort(
                          (a, b) =>
                            -b.sendingFacilityName.localeCompare(
                              a.sendingFacilityName
                            )
                        )}
                        renderOption={(props, option) => {
                          let object = facilityData.find(
                            (x) => x?.sendingFacilityId === option
                          );
                          return (
                            <li {...props} key={object?.sendingFacilityId}>
                              {object?.sendingFacilityName?.trim() +
                                "-" +
                                object?.clia?.trim()}
                            </li>
                          );
                        }}
                        sx={{
                          display: "inline-block",
                          width: 350,
                          "& input": {
                            width: 700,
                            height: 10,
                            bgcolor: "background.paper",
                            color: (theme) =>
                              theme.palette.getContrastText(
                                theme.palette.background.paper
                              ),
                          },
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        getOptionLabel={(option) => {
                          return (
                            facilityData
                              .find((x) => x?.sendingFacilityId === option)
                              ?.sendingFacilityName?.trim() +
                            "-" +
                            facilityData
                              .find((x) => x?.sendingFacilityId === option)
                              ?.clia?.trim()
                          );
                        }}
                        filterOptions={(options, params) => {
                          return filterOptions(options, params).map(
                            (x) => x["sendingFacilityId"]
                          );
                        }}
                      />
                    )}
                  </Form.Group>
                </Col>
                <Col xl={6}>
                  <Form.Group className="mb-3" controlId="isActive">
                    <Form.Label className="modalLabel generalFont">
                      Status <i className="text-danger">(required)</i>
                    </Form.Label>
                    <Form.Select
                      className="modalInput generalFont"
                      aria-label="Choose Item"
                      required
                      value={handleIsActive(form.isActive)}
                      onChange={(e) =>
                        setField(
                          "isActive",
                          e.target.value === "Active" ? true : false
                        )
                      }
                    >
                      <option hidden value="">
                        Choose Item
                      </option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              {isAddNew && <Row>
                <Col>
                <Form.Check
                    name="copyToSendingFacilityFlag"
                    value={copyToSendingFacilityFlag}
                    type="checkbox"
                    label="Copy to Sending Facility"
                    inline
                    onChange={(e) => {
                      setCopyToSendingFacilityFlag(!copyToSendingFacilityFlag);
                    }}
                    checked={copyToSendingFacilityFlag}
                  />
                </Col>
              </Row>}
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="addressLine1">
                    <Form.Label className="modalLabel generalFont">
                      Street Address 1
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      placeholder="Hint Text"
                      maxLength={255}
                      value={form.addressLine1}
                      onChange={(e) => setField("addressLine1", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="addressLine2">
                    <Form.Label className="modalLabel generalFont">
                      Street Address 2
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={255}
                      placeholder="Hint Text"
                      value={form.addressLine2}
                      onChange={(e) => setField("addressLine2", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="city">
                    <Form.Label className="modalLabel generalFont">
                      City
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={100}
                      placeholder="Hint Text"
                      value={form.city}
                      onChange={(e) => setField("city", e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="state">
                    <Form.Label className="modalLabel generalFont">
                      State
                    </Form.Label>
                    <Form.Select
                      className="modalInput generalFont"
                      aria-label="Choose Item"
                      value={form.state}
                      onChange={(e) => setField("state", e.target.value)}
                    >
                      <option hidden value="">
                        Choose Item
                      </option>
                      {_.sortBy(statesData, ["reference_Code_description"]).map(
                        (entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        }
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="zip">
                    <Form.Label className="modalLabel generalFont">
                      Zip
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={15}
                      placeholder="Hint Text"
                      value={form.zip}
                      onChange={(e) => setField("zip", e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="phoneNo">
                    <Form.Label className="modalLabel generalFont">
                      Phone Number
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      maxLength={20}
                      placeholder="Hint Text"
                      value={form.phoneNo}
                      onChange={(e) => setField("phoneNo", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              {isAddNew ? "Add" : "Update"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Performing Facility
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Performing Facility from the
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeFacility}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Facility Name"
                value={filter.searchNameText ? filter.searchNameText : ""}
                onChange={(e) =>
                  setFilterField("searchNameText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br /> <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Facility CLIA"
                value={filter.searchCliaText ? filter.searchCliaText : ""}
                onChange={(e) =>
                  setFilterField("searchCliaText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search City"
                value={filter.searchCityText ? filter.searchCityText : ""}
                onChange={(e) =>
                  setFilterField("searchCityText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">State</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "scroll",
                    overflowX: "hidden",
                  }}
                >
                  <FormGroup>
                    {statesData
                      .sort((a, b) =>
                        a.reference_Code_description >
                        b.reference_Code_description
                          ? 1
                          : -1
                      )
                      .map((item) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={statesCheckedValues.includes(
                                  item?.reference_Code_description
                                )}
                                onChange={handleStatesCheckboxChange}
                                name={item?.reference_Code_description}
                              />
                            }
                            label={item?.reference_Code_description}
                          />
                        );
                      })}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PerformingFacility;
